import React from 'react';
import { motion } from 'framer-motion';
import { SkullIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 sm:py-16 lg:py-24 relative bg-dark-bg bg-noise" data-id="element-143">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} className="glass-card p-5 sm:p-8 lg:p-12 relative overflow-hidden group" data-id="element-145">
          {/* Red warning accent */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-dark via-red-urgent to-red-dark opacity-80" data-id="element-146" />
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-red-urgent/10 rounded-full blur-3xl" data-id="element-147" />

          <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8 relative z-10" data-id="element-148">
            <div className="p-2.5 sm:p-3 bg-red-dark/20 rounded-lg border border-red-urgent/30 text-red-urgent" data-id="element-149">
              <SkullIcon className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-150" />
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white" data-id="element-151">
              EL PROBLEMA
            </h2>
          </div>

          <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-gray-300 relative z-10" data-id="element-152">
            <p data-id="element-153">
              <strong className="text-white font-semibold" data-id="element-154">
                No eres vago. No eres débil por naturaleza. Estás secuestrado.
              </strong>{' '}
              El mundo moderno ha sido diseñado científicamente para mantenerte
              dopado, cansado y sumiso.
            </p>
            <p data-id="element-155">
              La comida procesada, la pornografía instantánea y las
              notificaciones constantes han destruido tus receptores de
              dopamina. Tu cerebro ya no sabe cómo luchar por una recompensa
              real porque se acostumbró al placer fácil, falso y vacío.
            </p>
            <p className="text-lg sm:text-xl text-red-400 font-cinzel font-semibold mt-6 sm:mt-8 border-l-2 border-red-urgent pl-3 sm:pl-4" data-id="element-156">
              Estás viviendo como un esclavo en una arena donde tú eres la presa
              de tus propios vicios.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}